<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <label style="font-size: 15px !important">Arquivo ROS_VAL (Saneamento e Painel de obras)</label>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-row>
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue">
                <div>
                  <a href="javascript:void(0)" @click="baixarArquivoModeloRosVal()">Clique aqui</a>
                  para baixar o modelo para a importação.
                  <br />
                  OBS: O arquivo enviado precisa estar no formato
                  <b>UTF-8</b>
                  .
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-file-input
                  v-model="arquivoRosValFileObj"
                  label="Arquivo CSV"
                  placeholder="Selecione um arquivo CSV"
                  outlined
                  accept=".csv"
                  truncate-length="30"
                  :loading="arquivoRosValUploading"
                  loader-height="4"
                  :success="arquivoRosValId && arquivoRosValFileObj ? true : false"
                  :error-messages="errors"
                  @change="uploadNewFile($event)"
                  @click:clear="clearInputsArquivo()"
                />
              </validation-provider>
              <input type="hidden" name="upload-arquivo-ros-val" :value="arquivoRosValId" />
            </v-col>
          </v-row>
          <v-row class="mb-n5 mt-n2 mx-auto">
            <v-col cols="12" class="pl-n1 pt-0">
              <parametros-arquivo-csv
                :delimitador.sync="arquivoRosValDelimitador"
                :involucro.sync="arquivoRosValInvolucro"
                :escape.sync="arquivoRosValEscape"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';
  import ArquivosService from '@/services/ArquivosService';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    data: () => ({
      cabecalhoArquivo: [
        'Nr_TI',
        'Cd_SubODI',
        'VL_UC_ROA',
        'VL_COM_ROA',
        'VL_MOP_ROA',
        'VL_ST_ROA',
        'VL_JOA_ROA',
        'VL_OUT_ROA',
        'VL_TOT_ROA',
        'VL_UAR_FISC',
        'VL_COM_FISC',
        'VL_MOP_FISC',
        'VL_ST_FISC',
        'VL_JOA_FISC',
        'VL_OUT_FISC',
        'VL_TOT_FISC',
        'DATA_ENERGIZACAO_OBRA',
        'FLG_DOA_OE',
        'FLG_INCOR_OE',
        'FLG_PLPT_OE',
        'FLG_OAT'
      ]
    }),

    computed: {
      arquivoRosValId: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoRosVal.id;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoRosVal: { id: value } });
        }
      },
      arquivoRosValFileObj: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoRosVal.fileObj;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoRosVal: { fileObj: value } });
        }
      },
      arquivoRosValUploading: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoRosVal.uploading;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoRosVal: { uploading: value } });
        }
      },
      arquivoRosValDelimitador: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoRosVal.delimitador;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoRosVal: { delimitador: value } });
        }
      },
      arquivoRosValInvolucro: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoRosVal.involucro;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoRosVal: { involucro: value } });
        }
      },
      arquivoRosValEscape: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.arquivoRosVal.escape;
        },
        set(value) {
          this.$store.dispatch('setSimulacaoLaudoIncremental', { arquivoRosVal: { escape: value } });
        }
      }
    },

    methods: {
      baixarArquivoModeloRosVal() {
        this.$toast.info('Processando...', '', {
          position: 'topRight',
          timeout: 1250
        });

        SimulacoesLaudosIncrementaisService.baixarArquivoModeloRosVal()
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', 'Arquivo Ros Val Modelo.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao baixar arquivo modelo do sistema', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      },

      uploadNewFile(arquivo) {
        if (!arquivo) {
          this.clearInputsArquivo();
          return true;
        }

        this.arquivoRosValId = '';
        this.arquivoRosValUploading = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', arquivo);

        ArquivosService.uploadFile(formDataWithFile, {})
          .then(async (response) => {
            await this.validaHeader(
              response.data.arquivoId,
              this.arquivoRosValDelimitador,
              this.arquivoRosValInvolucro,
              this.arquivoRosValEscape,
              this.cabecalhoArquivo
            );

            this.arquivoRosValId = response.data.arquivoId;
          })
          .catch((err) => {
            if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
              this.$toast.error(err.data.erro, '', {
                position: 'topRight',
                timeout: 6000
              });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', {
                position: 'topRight'
              });
              console.error('Erro ao fazer upload: ', err);
            }

            this.arquivoRosValFileObj = null;
          })
          .finally(() => (this.arquivoRosValUploading = false));
      },

      clearInputsArquivo() {
        this.arquivoRosValId = '';
        this.arquivoRosValFileObj = null;
        this.arquivoRosValDelimitador = ';';
        this.arquivoRosValInvolucro = '"';
        this.arquivoRosValEscape = '"';

        this.$forceUpdate();
      },

      validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
        return ArquivosService.validarHeaderCSV(arquivoId, {
          delimitador,
          involucro,
          escape,
          cabecalhoEsperado
        }).catch((err) => {
          throw err;
        });
      }
    }
  };
</script>
